import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { get } from 'lodash';
import { change } from 'redux-form';
import { YesNoOptions } from 'Common/FormHelper';
import { ReduxFormButtonGroup } from 'Components/forms/ReduxFormButtonGroup';
import * as actions from 'Common/UserSettings/state/actions';
import * as CommonStateSelectors from 'State/selectors';
import { UserSettingsEnum } from 'Common/UserSettings/helpers/helper';

class UseStudentAddressButtonGroupContainer extends React.Component {
  getSetting = () => {
    const { formName, useStudentAddressSettings } = this.props;
    return get(
      useStudentAddressSettings,
      UserSettingsEnum.LettersUseStudentAddress + formName,
      false
    );
  };

  state = {
    value: this.getSetting(),
  };

  componentDidMount() {
    const { change, fieldName, formName } = this.props;
    change(formName, fieldName, this.getSetting());
  }

  handleChange = newValue => {
    const { formName, setLettersUseStudentAddressSetting } = this.props;
    setLettersUseStudentAddressSetting(newValue, formName);
    this.setState({ value: newValue });
  };

  render() {
    const { label, formName, fieldName, letter } = this.props;
    const { value } = this.state;

    return (
      <ReduxFormButtonGroup
        options={YesNoOptions}
        onChange={this.handleChange}
        value={value}
        label={label}
        formName={formName}
        fieldName={fieldName}
        letterType={letter}
      />
    );
  }
}

const mapStateToProps = state => {
  return {
    useStudentAddressSettings:
      state.UserSettingsState[CommonStateSelectors.getUserName(state)],
  };
};

const mapDispatchToProps = {
  ...actions,
  change,
};

export const UseStudentAddressButtonGroup = withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(UseStudentAddressButtonGroupContainer)
);



// WEBPACK FOOTER //
// ./src/common/Components/UseStudentAddressButtonGroup/UseStudentAddressButtonGroup.js